import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultRoleResource,
    RoleMutationResourceSchema,
    useRoleActions,
} from '../../../../../resource/resources/artifacts/role/roleResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { RoleContent } from './RoleContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const RoleView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const roleActions = useRoleActions()
    const roleQuery = roleActions.useGetResource(id);
    const updateRole = roleActions.useUpdateResource();
    const validateRole = roleActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: RoleMutationResourceSchema,
        defaultValues: defaultRoleResource,
        submitHandler: async (data) => {
            await updateRole.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: roleQuery.data,
    });

    return (
        <QueryBaseComponent name="Role" query={roleQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateRole.data}
                    metaDataInfo={roleQuery.data}
                    resourceType={ResourceType.ROLE}
                >
                    <Text c="dimmed">Role</Text>
                </ResourceValidationTitleBar>
                <RoleContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
